<template>
  <div style="width: 100%;height: fit-content;">
    <div class="header">
      <van-nav-bar :title="data.xuanfei_name" left-arrow @click-left="onClickLeft">
        <template #left>
          <van-icon name="arrow-left" size="22" color="#fff" />
        </template>
      </van-nav-bar>
    </div>
    <div style="height:12vw"></div>
    <div class="feiziInfo">
      <div class="topInfo">
        <div class="bg"></div>
        <div  v-if="Object.keys(data).length > 0 && data.img_url.length > 0" style="margin: 5px auto;display: flex;width: 90%;position: absolute;z-index: 10;left:50%;transform: translateX(-50%);">
          <img :src="$imgSrc(data.img_url[0])" alt="" style="display: block;width: 120px;height: 120px;border-radius: 10px;margin-right: 20px;">
          <div style="font-size: 20px;color: #fff;padding-top: 20px;">{{ data.xuanfei_name }} <span style="color: rgb(250, 154, 10);font-size: 14px;">{{ data.hight }}</span></div>
          
        </div>
        
        <!-- <div class="dianzanimg" @click="clickPraise">
          <div class="van-image" style="width: 60px; height: 60px;">
            <img src="/img/zan.c28032c8.png" class="van-image__img" style="object-fit: cover;" />
          </div>
          <p style="color: rgb(107, 34, 179); margin: 0px;">
            {{ data.dianzan }}
          </p>
        </div> -->
      </div>
      
      <div class="cenInfo">
        <div class="title">
          {{ $t('index.photos') }}
        </div>
        <div v-show="!showMsg">
          <div>
            <div class="imgswiper">
              <div v-for="(i, index) in data.img_url" :key="index"
                style="width: 200px; height: 200px; margin-right: 10px;">
                <div @click="onClickImg(index)" :class="['imgI van-image']"
                  style="width: 200px; height: 200px;">
                  <img :src="$imgSrc(i)" class="van-image__img" style="object-fit: cover;" />
                </div>
              </div>
            </div>
            <!-- <div class="van-image" style="width: 100%; height: 635px;">
              <img :src="$imgSrc(currentImage)" class="van-image__img" style="object-fit: cover;" />
            </div> -->
          </div>
        </div>
      </div>
      <div style="padding-bottom: 2vw; "></div>
      <div class="btmInfo">
        <div style="color: rgb(42, 20, 104); margin-bottom: 10px; font-weight: bold;">{{$t('index.personal_profile')}}</div>
        <div>
          <div style="color: #6b22b3; font-size: 14px;margin: 5px 0px;">
            {{ $t("index.height") }}:{{ data.hight }} {{ $t("index.bust") }}：{{ data.bust }}
          </div>
          <div style="width: 50%;display: flex;flex-wrap: wrap;gap: 10px;">
            <div class="item" v-for="(item, index) in data.flagArray" :key="index">{{ item }}</div>
          </div>
        </div>
        <div>
          <span style="color: rgb(107, 34, 179); font-size: 14px;">{{ $t("index.toll") }}：</span>
          <van-rate v-model="data.number" readonly color="#ffd21e" size="18px" />
        </div>
        <div style="color: rgb(107, 34, 179); font-size: 14px; margin: 5px 0px;">
          {{ $t("index.residence") }}：{{ data.class_name }}
        </div>
        <div style="color: rgb(83, 69, 137);">{{ data.jianjie }}</div>
        
        <div style="color: rgb(42, 20, 104); margin-bottom: 10px; font-weight: bold;margin-top: 30px;">{{$t('DatingInstructions')}}</div>
        <div style="color: #333; margin-bottom: 10px;margin-top: 20px;font-size: 14px;word-break: keep-all;line-height: 1.4;">{{$t('DatingText')}}</div>
      </div>
      
    </div>
    <div style="padding-bottom: 100px; "></div>
    <div class="yuyueBox" @click="toService">{{ $t("我想预订") }}</div>
  </div>
</template>

<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      showMsg: false,
      data: {},
      currentIndex: 0,
      currentImage: '',
      isPraised: false,
      player: null,
    };
  },
  methods: {
    getxuanfeidata() {
      Toast.loading({
        forbidClick: true,
        duration:0
      });
      this.$http({
        method: 'get',
        url: 'xuanfeidata',
        data: { id: this.$route.query.id }
      }).then(res => {
        this.data = res.data;
        const lanng = localStorage.getItem("lang");
        // this.data.flag.forEach(item => {
        //   const parts = item.flag.split('|')
        //   item.flag = parts[0]
        //   item.flagArray = item.flag.split('，');
        // })
        const parts = this.data.flag.split('|')
       
        lanng == 'zh' ? this.data.flag = parts[0] : lanng == 'en' ? this.data.flag = parts[1] : lanng == 'ja' ? this.data.flag = parts[2] : this.data.flag = parts[3]
        this.data.flagArray = this.data.flag?this.data.flag.split(','):[];
        this.currentImage = this.data.img_url[0];
        Toast.clear()
        console.log(this.data, 2222222222)
      })
    },
    toService() {
      const service = this.$store.getters.getBaseInfo;
      // console.log('service--->', service)
      if (service.iskefu == 1) {
        window.location.href = service.kefu
      }
    },
    onClick(name) {
      // console.log(name);
      if (name === 'phone') {
        this.showMsg = false
        if (this.player) {
          this.player.pause();
          // 确保 player 被置为空
        }
      } else {
        this.showMsg = true


      }

    },
    onClickImg(index) {
      this.currentIndex = index;
      this.currentImage = this.data.img_url[index];
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    clickPraise() {
      if (this.isPraised) {
        // 如果已经点赞，则减1
        this.data.dianzan--;
        this.isPraised = false;
      } else {
        // 如果未点赞，则加1
        this.data.dianzan++;
        this.isPraised = true;
      }
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          this.$toast(res.msg);
          this.list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    this.getxuanfeidata();

  },
  mounted() {
  },
  beforeDestroy() {
    // 销毁video.js播放器实例，避免内存泄漏
  },
};
</script>

<style scoped lang="less">
.van-nav-bar {
  background: linear-gradient(30deg, #7d76ef, #d63f8c) !important;
}

.van-nav-bar .van-icon {
  color: #fff !important;
}

.feiziInfo {
  background: #f2f2f5 url('../../assets/image/bgj.png') no-repeat center top / 100%;
}

.topInfo {
  position: relative;
  padding: 4vw 40px;
  height: 295px;
  .bg {
    width: 100%;
    height: 150px;
    background: linear-gradient(90deg, #7d76ef, #d63f8c);
    border-radius: 0px 0px 20px 20px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 0px;
    z-index: 0;
  }
}

.feiziInfo .topInfo div:first-child span:first-child {
  color: #2c1868;
  font-size: 5vw;
}

.topInfo .item {
  background: linear-gradient(50deg, #9b54ca, #e6557f);
  color: #fff;
  display: inline-block;
  border-radius: 20px;
  margin-right: 30px;
  font-size: 24px;
  padding: 16px;
  margin-bottom: 30px;
}

.yuyueBox {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  position: fixed;
  right: 50%;
  transform: translateX(50%);
  bottom: 40px;
  color: #fff;
  padding: 20px 30px;
  background: linear-gradient(50deg, #9b54ca, #e6557f);
  border-radius:12px;
}

.dianzanimg {
  position: absolute;
  top: 4vw;
  right: 7vw;
  text-align: center;
}

.cenInfo {
  padding: 4vw 20px 10px 20px;
  background: #fff;
  .title {
    font-size: 40px;
    font-weight: bold;
    color: #3D2A72;
  }
}

.imgswiper {
  width: 100%;
  overflow-x: scroll;
  margin: 4vw 0;
  display: flex;
  flex-wrap: nowrap;
}

.imgswiper .active {
  border: 10px solid #e54878;
}

.btmInfo {
  padding: 4vw 40px;
  background: #fff;


}

::v-deep .movie-video .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -100px;
}

.video-js {
  width: 100%;
  height: 336px;
  font-size: 24px;

}
</style>
